// Util tampilan Agenda Kegiatan (publik & APIK)
export const REALISASI = [
  { key: "belum", label: "Belum", cls: "bg-slate-100 text-slate-500" },
  { key: "berjalan", label: "Sedang Berjalan", cls: "bg-amber-50 text-amber-600" },
  { key: "terlaksana", label: "Terlaksana", cls: "bg-emerald-50 text-emerald-600" },
];

export const realisasiOf = (key) =>
  REALISASI.find((r) => r.key === key) || REALISASI[0];

const KEEP_UPPER = new Set(["PPID", "SPI", "RB", "ZI", "&"]);

// "KELEMBAGAAN & KERJA SAMA" -> "Tim Kelembagaan & Kerja Sama"
export const timLabel = (label) =>
  "Tim " +
  (label || "")
    .split(" ")
    .map((w) =>
      KEEP_UPPER.has(w)
        ? w
        : w.toLowerCase() === "dan"
          ? "dan"
          : w.charAt(0) + w.slice(1).toLowerCase()
    )
    .join(" ");

export const formatRupiah = (n) =>
  n == null || n === ""
    ? "—"
    : new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }).format(Number(n));
